<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")

  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="(item,key) in $t('sec1Items')")
        h4: AppLink(:to="`/solutions/${key}`" :title="item.title") {{item.title}}
        p {{item.desc}}


  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('exploreMantra')" tag="h2")
    .grid.is-tablet-6
      .column.u-mb-sm
        AppCardBox.u-textCenter
          AppLink(to="/services" :title="$t('exploreServices')"  class="cardBox-url")
          h3.u-mb-0 {{$t('exploreServices')}}
      .column.u-mb-sm
        AppCardBox.u-textCenter
          AppLink(to="/industries" :title="$t('exploreIndustries')"  class="cardBox-url")
          h3.u-mb-0 {{$t('exploreIndustries')}}


  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large" v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat solutions",
    "pageDesc":"Explore Baianat solutions for the different businesses realities and build your online presence.",
    "mantra":"Business solutions with |high customizations",
    "sec1Items":{
     "mobile-apps":{
        "title":"Mobile apps",
        "desc":"We design and develop custom mobile apps that are tailored to your industry needs and engaging for your clients."
      },
      "brand":{
        "title":"Brand",
        "desc":"Starting with your business needs and strategy. We build your brand to go beyond the visuals and communicate with your audience."
      },
      "store":{
        "title":"Store",
        "desc":"Create your own store  with all the features you need to expand your business online. Through Baianat store solutions, we help you create a seamless online experience."
      },
      "illustrations":{
        "title":"Illustrations",
        "desc":"Playing with visual elements to create custom illustration that could be patterns, imaginary characters or geometrical shapes."
      },
      "typeface":{
        "title":"Typeface",
        "desc":"We collaborate with you to create a custom type for your brand that works on digital, print and everywhere else."
      },
      "web-apps":{
        "title":"Web apps",
        "desc":"Build a website that matches with your business. Together,We develop and design web apps that thrive in the digital era."
      },
      "campaign":{
        "title":"Campaign",
        "desc":"Planning and executing strategic campaigns that lets you reach your audience on various channels."
      },
      "packaging":{
        "title":"Package",
        "desc":"Soaring materials and design for unforgettable unboxing experience that turns every purchase into an exciting journey."
      },
      "video":{
        "title":"Video",
        "desc":"Capitalize on video content in your campaigns, website or other channels. Communicate with your audience and go viral by evoking emotions."
      },
      "strategy":{
        "title":"Strategy",
        "desc":"Helping you turn into a strategy driven business by normalizing your processes and planning actions ahead."
      },
      "product":{
        "title":"Product",
        "desc":"Creating products that combine your features, our insights and customers’ needs. By prototyping, iterating and adopting a customer centric mentality."
      },
      "technology":{
        "title":"Technology",
        "desc":"Reveal new opportunities for your business by integrating a technological aspect into your production or operations."
      },
      "cms":{
        "title":"Content management system",
        "desc":"Managing your online content doesn't have to be painful. With our CMS services we let you control your publishing through a fully custom CMS or WordPress development."
      },
      "erp":{
        "title":"ERP",
        "desc":"Developing enterprise resources systems to help you run your organization smarter and manage your sales, inventory and all your business aspects."
      },
      "crm":{
        "title":"CRM",
        "desc":"Empowering your business with customer relationship management system so you could build long term relationships and eradicate your sales hassle."
      },
      "pos":{
        "title":"POS",
        "desc":"Link your front store with the back end operations through a smart point of sale that operates as an accounting hand as well."
      },
      "saas":{
        "title":"Saas solutions",
        "desc":"Modernize your software business with a custom saas solution that lets you reach more customers and easily upgrade your features."
      },
      "desktop-apps":{
        "title":"Desktop apps",
        "desc":"Reimaging desktop apps with cloud techniques that depend totally on using modern conversion-rate-optimizationss apps technology. With simplicity in mind, we create user friendly interfaces that works on Mac, Windows and linux."
      },

      "landing-pages":{
        "title":"Landing pages",
        "desc":"Whether for a product, event or mobile app, we help you build a landing page that converts your leads and drives your sales operations."
      },
     "wordpress":{
        "title":"WordPress",
        "desc":"Whether a company profile, a personal website or a services portal, we help you get the best out of WordPress and utilize its features."
      },
      "woocommerce":{
        "title":"Woocommerce",
        "desc":"We help design and develop your online store using WordPress and Woocommerce platform and customize its features around your business needs and operations scale."
      },
      "opencart":{
        "title":"Opencart",
        "desc":"Building ecommerce websites using Opencart smart solution for a faster process and easy maintenance in the future."
      },
      "magento":{
        "title":"Magento",
        "desc":"From cart customization to payment gateway integration, we help you build up a modern estore that drives your online sales operations."
      },
      "odoo":{
        "title":"Odoo",
        "desc":"We customize Odoo solutions around your business needs and build modules that roahnzies your departments work."
      }
    },
    "exploreMantra":"Explore by further |categories.",
    "exploreIndustries":"Industries",
    "exploreServices":"Services",
    "explorePlatforms":"Platforms",
    "cta":"Let's have <br> Coffee togther."

  },
  "ar": {
    "pageTitle":"حلول بيانات",
    "pageDesc":"اكتشف حلول بيانات لمختلف الأعمال التجارية وابدأ في بناء تواجدك على الإنترنت. ",
    "mantra":"حلول شديدة التخصيص |للأعمال التجارية.",
    "sec1Items":{
      "mobile-apps":{
          "title":"تطبيق",
          "desc":"نصمم ونطور تطبيقات الجوال المخصصة التي تعمل على تلبية احتياجات عملك و عملائك وفي نفس الوقت تزيد الوعي بعلامتك التجارية."
        },
        "brand":{
          "title":"علامة تجارية",
          "desc":"نبدأ من احتياجات عملك التجاري والاستراتيجية؛ لبناء علامتك التجارية التي تتجاوز الصور المرئية وتجعلك تتواصل أفضل مع جمهورك."
        },
        "store":{
          "title":"متجر",
          "desc":"قم بإنشاء متجرك الخاص واحصل على جميع المميزات التي تحتاجها من أجل توسيع نطاق عملك. من خلال الحلول التي توفرها بيانات نساعدك على إنشاء تجربة سلسة على الانترنت."
        },
        "illustrations":{
          "title":"تصميم الاليستريشن",
          "desc":"نلعب باستخدام العناصر المرئية من أجل إنشاء رسوم بالاليستريشن حيث يمكن أن تكون باترن أو شخصيات وهمية أو أشكالًا هندسية."
        },
        "typeface":{
          "title":"خط",
          "desc":"نتعاون سويًا من أجل إنشاء عائلة الخطوط المخصصة لعلامتك التجارية الذي يعمل في الجانب الرقمي أو في الطباعة وفي كل مكان آخر."
        },
        "web-apps":{
          "title":"موقع",
          "desc":"نعمل معك لبناء موقع يتناسب مع حجم عملك وكذلك هويتك التجارية، سوف نقوم برمجة وتصميم تطبيقات المواقع لنساعد عملك على النمو."
        },
        "campaign":{
          "title":"إنشاء الحملات الإعلانية",
          "desc":"نعمل على تخطيط وتنفيذ الحملات الاستراتيجية التي تتيح لك الوصول إلى جمهورك المستهدف من خلال القنوات المختلفة."
        },
        "packaging":{
          "title":"تصميم الأغلفة",
          "desc":"تترك العلامة التجارية إنطباعًا من خلال المواد والتصميم المستخدم في تجربة التغليف؛ لهذا نساعدك على  تحويل كل عملية إلى تجربة مثيرة."
        },
      "video":{
        "title":"الفيديو",
        "desc":"احصل على الاستفادة القصوى من محتوى الفيديو في حملاتك، موقعك، أو أي قنوات أخرى. تواصل مع جمهورك واجعل محتواك منتشرًا وجذابًا للانتباه."
      },
      "strategy":{
        "title":"الاستراتيجية",
        "desc":"نساعدك على جعل جميع أعمالك التجارية مدفوعة بالاستراتيجية من خلال تسوية عملياتك وتخطيط كافة الإجراءات المستقبلية."
      },
      "product":{
        "title":"المنتج",
        "desc":"نعمل سويًا من أجل إنشاء منتجات تجمع بين المميزات الخاصة بك والرؤى التي نحصل عليها، واحتياجات العملاء. من خلال النموذج الأولى والتكرار والاهتمام بالمستخدم. "
      },
      "technology":{
        "title":"التكنولوجيا",
        "desc":"نكشف عن فرص جديدة لعملك التجاري من خلال دمج الجانب التكنولوجي في مختلف العمليات والانتاج."
      },
      "cms":{
        "title":"نظام إدارة المحتوى",
        "desc":"نتيح لك التحكم الكامل في عمليات النشر من خلال نظام إدارة المحتوى كمثال ووردبريس؛ ليسهل عليك إدارة محتواك و تركز على أعمالك بنفسك."
      },
      "erp":{
        "title":"أنظمة ادارة الموارد",
        "desc":"نعمل على تطوير أنظمة إدارة الموارد لمساعدتك في إدارة مؤسستك بشكل أكثر ذكاءً وإدارة مبيعاتك وجميع جوانب عملك."
      },
      "crm":{
        "title":"نظام إدارة علاقات العملاء",
        "desc":"نمكن عملك من خلال نظام إدارة علاقات العملاء حتى تتمكن من بناء علاقات طويلة الأجل معهم  والقضاء على متاعب المبيعات الخاصة بك."
      },
      "pos":{
        "title":"نقاط البيع",
        "desc":"نساعدك على ربط متجرك الأمامي بالعمليات الداخلية من خلال نقطة بيع ذكية تعمل كجهة محاسبة لعملك."
      },
      "saas":{
        "title":"تطبيقات ساس",
        "desc":"قم بتحديث أعمال البرامج الخاصة بك باستخدام حلول ساس المخصصة التي تتيح لك الوصول إلى المزيد من العملاء وتحديث مميزاتك بسهولة."
      },
      "desktop-apps":{
        "title":"تطبيقات الويب",
        "desc":"ندعم وجودك الرقمي من خلال تطبيقات الويب سريعة الاستجابة والقابلة للتكيف التي تحتوي على مميزات مخصصة حتى تتمكن من الازدهار في العصر الرقمي."
      },
      "landing-pages":{
        "title":"صفحات الهبوط",
        "desc":"سواء لمنتج أو فاعلية أو تطبيق، نساعدك على إنشاء صفحة الهبوط المناسبة التي تحول العملاء المحتملين وتزيد المبيعات."
      },
      "wordpress":{
        "title":"برمجة وتصميم ووردبريس",
        "desc":"سواء تريد ملف تعريف للشركة أو موقعًا شخصيًا ..وغيره سوف نساعدك في الحصول على أفضل إمكانات ووردبريس حتى تتمكن من الاستفادة من مميزاته."
      },
      "woocommerce":{
        "title":"ووكومرس",
        "desc":"نساعدك على تصميم وتطوير متجرك الإلكتروني من خلال الاعتماد على منصة ووردبريس ووكومرس وكذلك تخصيص المميزات بما يتناسب مع احتياجات عملك وحجم عملياتك."
      },
      "opencart":{
        "title":"برمجة وتصميم أوبن كارت",
        "desc":"يمكنك الآن بناء مواقع التجارة الإلكترونية باستخدام الأوبن كارت الذي يوفر لك سرعة في الأداء والسهولة في الصيانة من أجل المستقبل."
      },
      "magento":{
        "title":"برمجة و تصميم ماجنتو",
        "desc":"بداية من تخصيص عربة التسوق إلى تكامل بوابة الدفع، نساعدك على إنشاء متجر حديث يقود عمليات المبيعات عبر الإنترنت بكل سهولة."
      },
      "odoo":{
        "title":"أودو",
        "desc":"نوفر حلول أودو التي تتماشى مع احتياجات عملك ونبني الوحدات التي تعمل بكفاءة مع الأقسام المختلفة لعملك."
      }
    },
    "exploreMantra":"استكشف المزيد بما |يناسب احتياجات أعمالك.",
    "exploreIndustries":"الصناعات",
    "exploreServices":"الخدمات",
    "explorePlatforms":"المنصات",
    "cta":"دعنا نتناول القهوة <br> سويًا."
  }
}
</i18n>
